$(document).ready(function() {
//   setTimeout(function() {
// $('#insta-feed a').wrapAll('<div class="link-wrapper"></div>');
//      }, 2000);
  $('#insta-feed').parent().parent().addClass('new-class');
   
});


$( document ).ready(function() {
$('ul.custom-slider-sect').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  // $(".bar-time i.fa.fa-bars").click(function(){
  //   $(".main-toggle-sect-wrapp").addClass("toggle-cust");
  //   $(".main-toggle-sect-wrapp").css("display", "block");
  // });
  // $(".bar-time i.fa.fa-times").click(function(){
  //   $(".main-toggle-sect-wrapp").removeClass("toggle-cust");
  //   $(".main-toggle-sect-wrapp").css("display", "none");
  // });
  // $("i.fa.fa-bars").click(function(){
  //    $(".fa.fa-times").addClass("active");
  //   $(".fa.fa-bars").removeClass("active");
    
  // });$("i.fa.fa-times").click(function(){
  //   $(".fa.fa-bars").addClass("active");
  //   $(".fa.fa-times").removeClass("active");
  // });
 

//    $(".bar-time i.fa.fa-bars").click(function(){
//       $('body').addClass('sticky-back')
//     });
// $(".bar-time i.fa.fa-times").click(function(){
//       $('body').removeClass('sticky-back')
//     });



$(".icon__menu__open").click(function() {
	
    $(".nav__appear").addClass("active");
});
$(".icon__menu__close").click(function() {
	
    $(".nav__appear").removeClass("active");
});

    $(".icon__menu__open").click(function(){
      $('body').addClass('sticky-back-menu')
    });
$(".icon__menu__close").click(function(){
      $('body').removeClass('sticky-back-menu')
    }); 


$('.main-hotest-slid-cls').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


   $('.featured_main_image').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
  nextArrow: '<button type="button" class="slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
  fade: true,
  asNavFor: '.featured_thumb_nail_image'
});
$('.featured_thumb_nail_image').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.featured_main_image',
  dots: false,
  arrows: true,
  vertical: true,
  verticalSwiping: true,
  focusOnSelect: true,
   responsive: [
    {
        breakpoint: 1320,
        settings: {
         vertical: true,
          slidesToShow: 3,
          slidesToScroll: 1
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 480,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    }
    ]
});


    $(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(200);
      $(".set > a i")
        .removeClass("fa fa-chevron-up")
        .addClass("fa fa-chevron-down");
    } else {
      $(".set > a i")
        .removeClass("fa fa-chevron-up")
        .addClass("fa fa-chevron-down");
      $(this)
        .find("i")
        .removeClass("fa fa-chevron-down")
        .addClass("fa fa-chevron-up");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".content")
        .slideDown(200);
    }
  });

 setTimeout(function() {
 $("button.btn.btn-info.btn-lg").insertAfter(".ymq-options-box.ymq-options-box-15.ymq-shopify-option-box .ymq-option-title");
   }, 100);

setTimeout(function() {
    var vbvb= $("li.product__media-item.grid__item.slider__slide.is-active .product__media.media.media--transparent img").attr("src");
   $("a.slick-slide.slick-current.slick-active img").attr('src',vbvb);
     }, 100);
  $("label.custom-label").click(function(){
setTimeout(function() {
    var vbvb= $("li.product__media-item.grid__item.slider__slide.is-active .product__media.media.media--transparent img").attr("src");
   $("a.slick-slide.slick-current.slick-active img").attr('src',vbvb);
     }, 500);
});
});

